<template>
  <div>
    <div class="chat-input text-center w-100 b-solid-cs mb-3">
      <div class="d-flex align-items-center p-2">
        <textarea
          v-model="newMessage"
          @keydown.enter.prevent="sendMessage"
          :placeholder="`${$t('Chat here')}...`"
          class="text-placeholder-cs"
        ></textarea>
        <button class="mr-2 attach position-relative">
          <img :src="`${publicPath}/img/rcp/attachment.svg`" />
          <FileComponent
            @file-updated="captureFile($event)"
            :key="'file'"
          ></FileComponent>
        </button>
        <button
        @click="sendMessage"
        >
          <img
            :src="`${publicPath}/img/rcp/send.svg`"
            class="cursor-pointer"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FileComponent from "@/components/FileComponent";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      newMessage: "",
    };
  },
  components: {
    FileComponent,
  },
  methods: {
    captureFile($event) {
      this.$emit("capture-file", $event);
    },
    sendMessage() {
      if (this.newMessage) {
        this.$emit("send-message", this.newMessage);
        this.newMessage = "";
      }
    },
  },
  mounted: function () {
    this.message = "";
  },
  created() {
    const theme =
      process.env.VUE_APP_THEME != "" && process.env.VUE_APP_THEME != 1
        ? process.env.VUE_APP_THEME
        : "default";
    require(`@/assets/css/${theme}/chat.css`);
  },
};
</script>
